"use client";

import { useState, type FormEvent } from "react";
import { useRouter } from "next/navigation";
import { TokenLinkGate, TokenLinkLayout } from "@/components/TokenLinkGate";
import { Button, Input } from "@/components/ui";

export default function AceitarConvitePage() {
  return (
    <TokenLinkLayout
      title="Aceitar convite"
      heroTitle="ASV Platform"
      heroBody="Defina seu nome e uma senha para concluir o convite."
      description="Se o link tiver expirado, peça um novo a quem te cadastrou."
    >
      <TokenLinkGate
        checkPath="/api/v1/session/accept-invite/check"
        stripPath="/aceitar-convite"
        newLinkHref="/entrar"
        newLinkLabel="Solicitar novo link"
      >
        {(token) => <AcceptInviteForm token={token} />}
      </TokenLinkGate>
    </TokenLinkLayout>
  );
}

function AcceptInviteForm({ token }: { token: string }) {
  const router = useRouter();
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError("");
    if (!displayName.trim() || !password) {
      setError("Informe o nome e a senha.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch("/api/v1/session/accept-invite", {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json", accept: "application/json" },
        body: JSON.stringify({
          token,
          password,
          display_name: displayName.trim(),
        }),
      });
      if (res.ok) {
        router.push("/entrar");
        return;
      }
      const body = (await res.json().catch(() => null)) as { message?: string } | null;
      setError(body?.message ?? "Não foi possível aceitar o convite");
    } catch {
      setError("Não foi possível conectar. Tente novamente em instantes.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <form method="post" className="flex flex-col gap-5" onSubmit={submit} noValidate>
      <Input
        label="Nome"
        id="invite-name"
        type="text"
        autoComplete="name"
        required
        value={displayName}
        onChange={(event) => setDisplayName(event.target.value)}
      />
      <Input
        label="Senha"
        id="invite-password"
        type="password"
        autoComplete="new-password"
        required
        value={password}
        onChange={(event) => setPassword(event.target.value)}
      />
      {error ? (
        <p role="alert" className="notice error">
          {error}
        </p>
      ) : null}
      <Button type="submit" variant="primary" loading={loading} className="w-full">
        Definir senha
      </Button>
    </form>
  );
}
